import {BaseDTO} from './_baseDTO.interface';
import {DamageDTO} from './damageDTO.interface';
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface DamageSeverityDTO extends BaseIntDTO {
  damageId: number;
  damage: DamageDTO;
  damageSeverityDescription: string;
}
